import { Component, Inject } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { EnumHelper } from 'common';
import {
  BankingTransactionFilters,
  BankingTransactionQueryParams,
  BankingTransactionStatus,
  BankingTransactionType,
} from '../banking.model';

@Component({
    selector: 'ifb-banking-transaction-list-filter-dialog',
    templateUrl: './banking-transaction-list-filter-dialog.component.html',
    standalone: false
})
export class BankingTransactionListFilterDialogComponent {
  form: UntypedFormGroup;
  today = new Date();

  bankingTransationStatusOptions = EnumHelper.getNamesAndValues(BankingTransactionStatus);
  bankingTransationTypeOptions = EnumHelper.getNamesAndValues(BankingTransactionType);

  constructor(
    readonly dialogRef: MatDialogRef<BankingTransactionListFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: UntypedFormBuilder,
  ) {
    this.form = this.formBuilder.group({
      fromDate: new UntypedFormControl(this.data.query.fromDate ? new Date(this.data.query.fromDate) : undefined, {
        validators: null,
        updateOn: 'blur',
      }),
      toDate: new UntypedFormControl(this.data.query.toDate ? new Date(this.data.query.toDate) : undefined, {
        validators: null,
        updateOn: 'blur',
      }),
      includePending: this.data.query.includePending === 'true' || false,
    });
  }

  static show(dialog: MatDialog, query: BankingTransactionQueryParams): Observable<any> {
    return dialog
      .open(BankingTransactionListFilterDialogComponent, {
        data: { query },
        closeOnNavigation: true,
      })
      .afterClosed();
  }

  onDateChange(): void {
    const control = this.form.get('fromDate');
    if (!(control.value instanceof Date)) control.setValue(undefined);
  }

  onConfirmed(formValues: unknown): void {
    this.dialogRef.close(new BankingTransactionFilters(formValues));
  }
}
